var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"no-gutters":_vm.$vuetify.breakpoint.smAndUp}},[_c('div',{staticClass:"font-weight-bold mb-3"},[_vm._v(_vm._s(_vm.act.title))]),_c('v-card',{staticStyle:{"height":"100vh","width":"100%"},attrs:{"elevation":"0"}},[_c('vue-pdf-app',{attrs:{"pdf":_vm.act.theory.file.url +'#toolbar=0',"config":_vm.config}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }